import { Pipe, PipeTransform } from '@angular/core';
import { WorkItem } from '../models/work-item';

// tslint:disable-next-line:use-pipe-transform-interface

export class WorkItemLinkFilterByTypeName implements PipeTransform {
  transform(selectedLinkType: string, arr: any[]): any[] {
    if (selectedLinkType !== null && selectedLinkType !== 'all') {
      let outputArr: any[] = arr.filter(item => item.linkName === selectedLinkType);
      return outputArr;
    }
    return arr;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'workItemLinkFilterByTypeName', pure: true }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class GroupWorkItemLinks implements PipeTransform {
  transform(arr: any[], workItemId: string): any[] {
    /**
     * [{
     *     linkType:
     *     linkDirection:
     *     workItems: workitem[]
     * }]
     *
     */
    let linkTypes = arr.reduce((ltypes, curr_val) => {
      if (ltypes.findIndex(ltype => curr_val.linkType.id === ltype.id) === -1) {
        return [...ltypes, curr_val.linkType];
      } else {
        return [...ltypes];
      }
    }, []);

    let op = [];
    linkTypes.forEach(linkType => {
      const linksOfLinkType = arr.filter(link =>
        link.linkType.id === linkType.id);
      let forward = [];
      let reverse = [];
      let forwardLinks = [];
      let reverseLinks = [];
      linksOfLinkType.forEach(link => {
        if (link.source.id === workItemId) {
          forward.push({...link.target, ...{newlyAdded: link.newlyAdded}});
          forwardLinks.push(link);
        }
        if (link.target.id === workItemId) {
          reverse.push({...link.source, ...{newlyAdded: link.newlyAdded}});
          reverseLinks.push(link);
        }
      });
      if (forward.length) {
        op.push({
          linkType: linkType,
          linkDirection: 'forwardName',
          workItems: forward,
          links: forwardLinks
        });
      }
      if (reverse.length) {
        op.push({
          linkType: linkType,
          linkDirection: 'reverseName',
          workItems: reverse,
          links: reverseLinks
        });
      }
    });
    return op;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'groupWorkItemLinks', pure: true }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

// tslint:disable-next-line:use-pipe-transform-interface

export class WorkItemLinkTypeFilterByTypeName implements PipeTransform {
  transform(selectedLinkType: string, arr: any[]): any[] {
    if (selectedLinkType !== 'all') {
      let outputArr: any[] = arr.filter(item => item.name === selectedLinkType);
      return outputArr;
    }
    return arr;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'workItemLinkTypeFilterByTypeName', pure: true }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
